/* Contact us Form */
if (document.getElementById('ContactFormCountry')) {
  document.getElementById('ContactFormCountry').addEventListener('change', function() {
    const statesDropdown = document.getElementById('statesDropdown');
    const statesField = document.getElementById('statesField');
    
    if (this.value !== 'United States of America') {
      statesDropdown.style.display = 'none';
      statesField.style.display = 'block';
    } else {
      statesDropdown.style.display = 'block';
      statesField.style.display = 'none';
    }
  });
}

/* Collection Color Swatch Expand */
document.body.addEventListener('click', function(event) {
  if (event.target.classList.contains('swatch-plus')) {
    event.target.closest('.grid-product__colors').classList.add('expand');
  }
});

// Product Page
if (document.body.classList.contains('template-product')) {
  function showSwatchProductImages(color) {
    const productThumbs = document.querySelectorAll('.product__thumbs img');
    const productTitle = document.querySelector('.product-section').getAttribute('data-product-title');
    
    productThumbs.forEach(img => {
      const productThumb = img.closest('.product__thumb-item');
      productThumb.style.display = 'none';
      
      const altText = img.getAttribute('alt');
      if (altText) {
        if (altText === color || altText === '' || altText === productTitle || altText.includes('.mp4')) {
          productThumb.style.display = 'block';
        }
      }
    });
  }

  const checkForActiveColor = setInterval(function() {
    const checkedColorSwatch = document.querySelector('.variant__input--color-swatch:checked');
    if (checkedColorSwatch) {
      showSwatchProductImages(checkedColorSwatch.value);
      clearInterval(checkForActiveColor);
    }
  }, 100);

  document.body.addEventListener('click', function(event) {
    if (event.target.classList.contains('color-swatch')) {
      showSwatchProductImages(event.target.textContent.trim());
    }
  });
}
/* Careers Page */
if (document.getElementById('careers')) {
  var bookID = "1QtYo_642KBbCTMi38ymkQv5IZjxfwrEv8PR8ShhhHfs",
      sheetID = "128751278",
      qry = encodeURIComponent("SELECT A, B, C WHERE D = TRUE ORDER BY A ASC"),
      url = "https://docs.google.com/spreadsheets/d/" + bookID + "/gviz/tq?tqx=out:csv&tq=" + qry + "&gid=" + sheetID,
      template = document.querySelector('.career-template').innerHTML;

  fetch(url)
    .then(response => response.text())
    .then(data => {
      data = Papa.parse(data, { header: true });
      data = data.data;
      
      if (data.length > 0) {
        data.forEach(item => {
          document.querySelector('.career-template .title').innerHTML = item.Title;
          document.querySelector('.career-template .shortd').innerHTML = item.ShortDescription;

          fetch(item.GoogleDocURL)
            .then(response => response.text())
            .then(nesteddata => {
              // Process the nested HTML data
              nesteddata = nesteddata.split('</style>')[1].split('<div id="footer">')[0];

              // Set the long description and clean up the content
              const longDescription = document.querySelector('.career-template .longd');
              longDescription.innerHTML = nesteddata;
              
              // Remove classes from specific tags
              longDescription.querySelectorAll('p, span, ul, li').forEach(el => el.removeAttribute('class'));
              
              // Style elements with '**' as bold
              longDescription.querySelectorAll('span').forEach(span => {
                if (span.innerHTML.includes('**')) {
                  span.style.fontWeight = 'bold';
                  span.innerHTML = span.innerHTML.replace('**', '');
                }
              });

              // Append the processed content to #careers
              document.getElementById('careers').insertAdjacentHTML('beforeend', document.querySelector('.career-template').innerHTML);

              // Reset the template for the next iteration
              document.querySelector('.career-template').innerHTML = template;
            })
            .catch(error => console.error('Error fetching nested data:', error));
        });
      } else {
        document.querySelector('#careers .no-careers').style.display = 'block';
      }
    })
    .catch(error => console.error('Error fetching spreadsheet data:', error));
}

document.addEventListener("DOMContentLoaded", function() {
  let lazyBackgrounds = document.querySelectorAll('.lazy-background');

  // IntersectionObserver to check if elements are in the viewport
  let observer = new IntersectionObserver(function(entries, observer) {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        // Load background image
        entry.target.style.backgroundImage = `url(${entry.target.getAttribute('data-src')})`;
        observer.unobserve(entry.target); // Stop observing once loaded
      }
    });
  });

  // Start observing lazy background elements
  lazyBackgrounds.forEach(background => {
    observer.observe(background);
  });
});

function getToday() {
  var today = new Date();
  var dd = today.getDate();
  var mm = today.getMonth() + 1; //January is 0!
  var yyyy = today.getFullYear();
  if (dd < 10) { dd = '0' + dd; }
  if (mm < 10) { mm = '0' + mm; }
  return yyyy + '-' + mm + '-' + dd;
}

function getPanBy(zoom) {
  if($(window).width() > 1000) {
    return (($(window).width() / zoom)*-1)		
  } else {
    return 50;
  }	
}

function delimit(txt,del) {
  if(txt.length > 0) { return (del + ' ') } else { return '' }
}

var rad = function(x) {
  return x * Math.PI / 180;
};

var getDistance = function(lat1, lon1, lat2, lon2 ) {
  var R = 6378137; // Earth’s mean radius in meter
  var dLat = rad(lat2 - lat1);
  var dLong = rad(lon2 - lon1);
  var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(rad(lat1)) * Math.cos(rad(lat2)) *
      Math.sin(dLong / 2) * Math.sin(dLong / 2);
  var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  var d = R * c;
  d = d * 0.0006213712; // converts to miles
  d = d + d*0.43;
  return d; // returns the distance in miles
};